<form novalidate (ngSubmit)="submit(formGroup.value)" [formGroup]="formGroup">
	<p [innerHtml]="'forgot-password.info' | translate" role="heading"></p>

	<div class="obg-m-forgot-password-content">
		<mat-form-field class="obg-m-forgot-password-username">
			<input
				matInput
				type="email"
				formControlName="username"
				test-id="forgot-password-username"
				data-test-id="forgot-password-username"
				[placeholder]="'forgot-password.email.placeholder' | translate"
			/>
		</mat-form-field>
		<obg-common-validation-renderer
			[input]="formGroup.controls.username"
			[disabled]="formGroup.disabled"
			translationPrefix="forgot-password.email"
		>
		</obg-common-validation-renderer>
	</div>

	<div class="obg-m-forgot-password-actions">
		<button
			mat-flat-button
			class="forgot-password-submit-btn"
			color="accent"
			type="submit"
			test-id="forgot-password-submit"
			data-test-id="forgot-password-submit"
			[disabled]="formGroup.invalid"
		>
			{{ 'forgot-password.reset-password' | translate }}
		</button>
		<span class="sga-warning" *ngIf="isSgaJurisdiction$ | async">
			{{ 'sga-forgot-password.note' | translate }}
			<a [obgRouteLink]="loginRouteLink"> {{ 'sga-forgot-password.link-description' | translate }} </a>
		</span>
	</div>

	<span class="obg-m-forgot-password-error" *ngIf="hasFailed$ | async"
		>{{ 'forgot-password.e_forgottenpasswords' | translate }}</span
	>
</form>
